import $ from "jquery";

// $(document).ready(function() {
//     function startRafScroll($el, scrollDistance, duration) {
//         // Duplicate content so there's a seamless transition
//         const originalContent = $el.html();
//         $el.append(originalContent);

//         let startTime = null;
//         let currentY = 0;

//         function rafStep(timestamp) {
//             if (!startTime) {
//                 startTime = timestamp;
//             }
//             // Elapsed time in ms
//             const elapsed = timestamp - startTime;
//             // Fraction of the total duration, 0.0 -> 1.0
//             let progress = elapsed / duration;
//             if (progress > 1) {
//                 progress = 1;
//             }

//             // In “linear” motion, position is a direct ratio of the total distance
//             currentY = progress * scrollDistance;
//             // Move up
//             $el.css('transform', `translateY(-${currentY}px)`);

//             if (progress < 1) {
//                 // Keep going
//                 requestAnimationFrame(rafStep);
//             } else {
//                 // Once we reach the full scrollDistance,
//                 // reset to 0 and do it again for an infinite loop
//                 $el.css('transform', 'translateY(0)');
//                 startTime = null;
//                 requestAnimationFrame(rafStep);
//             }
//         }

//         requestAnimationFrame(rafStep);
//     }

//     $('.card_animate_con').each(function(index) {
//         const $this = $(this);
//         // Distance to scroll = the container’s current scrollHeight
//         const originalHeight = $this[0].scrollHeight;
//         if (originalHeight === 0) {
//             return;
//         }
//         // Increase time for more “frames” over a longer duration,
//         // but keep it linear in draw calls
//         let durationMs = (index === 0 ? 10000 : 16000);

//         // Kick off the requestAnimationFrame-based scroll
//         startRafScroll($this, originalHeight, durationMs);
//     });
// });